"use client";
import { allIntegrationData } from "@/components/home/Integration/tabs-integration/IntegrationsData";
import Image, { StaticImageData } from "next/image";
import AuthButton from "./AuthButton";

interface ProductLink {
  icon?: string | StaticImageData;
  url?: string;
  label?: string;
}

interface SectionLinks {
  title: string;
  links: ProductLink[];
}

interface KrooloLinks {
  label: string;
  url: string;
  icon: StaticImageData;
  image?: StaticImageData;
}

interface CompareLinks {
  label: string;
  url: string;
  icon: StaticImageData;
}

interface AiToolsLink {
  label: string;
  url: string;
  icon: StaticImageData;
}

interface AllProductsNavProps {
  krooloLinks?: KrooloLinks[];
  allProductLinks?: ProductLink[];
  compareLinks?: CompareLinks[];
  integrationLinks?: { label: string; url: string; icon: StaticImageData }[];
  krooloAiLinks?: KrooloLinks[];
  aiToolsLinks?: AiToolsLink[];
}

const IntegrationNav = () => (
  <>
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3 lg:grid-cols-4">
      {allIntegrationData.map((item) => (
        <div key={item.id}>
          <a
            href={item.url}
            rel="noreferrer"
            className="flex items-center gap-3 text-sm font-normal text-[#202020]"
          >
            <Image src={item.icon} alt={item.title} className="w-[2rem]" />
            <button>{item.title}</button>
          </a>
        </div>
      ))}
    </div>
    <div className="col-span-2 mt-4 flex justify-center">
      <AuthButton
        type="integrationButton"
        text="View all Integrations"
        url="/integrations"
        transparent
        target="none"
        textColor="text-[#484848]"
        textWeightMedium
      />
    </div>
  </>
);

const AllProductsNav: React.FC<AllProductsNavProps> = ({
  krooloLinks = [],
  allProductLinks = [],
  compareLinks = [],
  integrationLinks = [],
  krooloAiLinks = [],
  aiToolsLinks = [],
}) => {
  const sections: SectionLinks[] = [
    { title: "Kroolo", links: krooloLinks || [] },
    { title: "All Features", links: allProductLinks || [] },
    { title: "Kroolo AI", links: krooloAiLinks || [] },
    { title: "AI Tools", links: aiToolsLinks || [] },
    { title: "Compare", links: compareLinks || [] },
    { title: "Integrations", links: integrationLinks || [] },
  ];

  return (
    <div className="mb-16 mt-1 h-[calc(100dvh-246px)] overflow-y-auto border-b-[0.25px] border-[#535252] pb-4 text-white">
      {sections.map((section, sectionIdx) => (
        <div key={sectionIdx} className="mb-4">
          <h3 className="mb-2 text-base font-semibold text-[#202020]">
            {section.title}
          </h3>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3 lg:grid-cols-4">
            {section.links && Array.isArray(section.links) && section.links.length > 0
              ? section.links.map((link, linkIdx) => (
                <a
                  href={link.url}
                  rel="noreferrer"
                  key={linkIdx}
                  className="mb-2 flex items-center gap-2 p-1 text-sm"
                >
                  <Image
                    src={link.icon || ""}
                    alt={link.label || ""}
                    width={16}
                    height={16}
                    className=""
                  />
                  <p className="text-sm font-normal text-[#202020]">
                    {link.label}
                  </p>
                </a>
              ))
              : null}
          </div>
        </div>
      ))}
      <IntegrationNav />
    </div>
  );
};

export default AllProductsNav;
